import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["popover", "name"];

  connect() {
    document.querySelectorAll("[data-vocabulary-id]").forEach((span) => {
      span.classList.add(
        "underline",
        "decoration-dotted",
        "underline-offset-4",
        "cursor-help",
        "hover:text-primary-blue-600",
      );

      span.dataset.action =
        "mouseenter->vocabulary-preview#show mouseleave->vocabulary-preview#hide";
    });
  }

  async show(event) {
    const vocabulary = await this.fetchVocabulary(
      event.target.dataset.vocabularyId,
    );

    this.popoverTarget.style.display = "flex";
    this.popoverTarget.style.left = `${event.target.getBoundingClientRect().left}px`;
    this.popoverTarget.style.top = `calc(${event.target.getBoundingClientRect().top - this.popoverTarget.getBoundingClientRect().height}px - 0.5rem)`;
    this.popoverTarget.style.opacity = 1;

    this.nameTarget.textContent = vocabulary.name;
  }

  hide() {
    this.popoverTarget.style.display = "none";
    this.popoverTarget.style.opacity = 0;
  }

  async fetchVocabulary(vocabularyId) {
    return await (
      await fetch("/admin/vocabularies/" + vocabularyId + ".json")
    ).json();
  }
}
